import React from 'react';
import { BrandIcon, Icon } from '@tt/ui';
import PropTypes from 'prop-types';

const cards = {
  'american express': 'amex',
  'amex': 'amex',
  'visa': 'visa',
  'discover': 'discover',
  'mastercard': 'mastercard',
};

const PaymentCardIcon = ({ brand, ...props }) => {
  const lowerCaseBrand = brand ? brand.toLowerCase() : null;

  const cardBrandName = cards[lowerCaseBrand];
  if (cardBrandName) {
    return <BrandIcon name={cardBrandName} {...props} />;
  }
  return <Icon name="credit-card" {...props} />;
};

PaymentCardIcon.propTypes = {
  brand: PropTypes.string,
};

export default PaymentCardIcon;
